import styled from 'styled-components'
import IMAGES from '../../images'

export const MenuIconWrapper = styled.span`
  position: relative;
  width: 22px;
  height: 39px;
  background: url(${IMAGES.MENU_ICON}) center center no-repeat;
  background-size: cover;
  @media only screen and (max-width: 768px) {
    width: 16px;
    height: 28px;    
  }
  
  .circle {
    position: absolute; /* Để có thể định vị phần tử bên trong nó */
    top: 7px;
    left: 50%;
    transform: translateX(-50%);
    width: 6px;
    height: 6px;
    border: 2px solid #fff;
    border-radius: 50%;
    transition: opacity 0.2s ease;
    opacity: 0;
  }
  .circle:before {
    content: "";
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%);
    width: 52px;
    border-radius: 50%;
    height: 4px;
    background-image: linear-gradient(to right, transparent, rgba(255, 255, 255, 1), transparent);
    background-size: 100% 10px;
    background-position: center center;
    background-repeat: no-repeat;
    transition: opacity 0.2s ease;
    opacity: 0;
  }

  .circle:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: -21px;
    width: 44px;
    border-radius: 50%;
    height: 4px;
    background-image: linear-gradient(to right, transparent, rgba(255, 255, 255, 1), transparent);
    background-size: 100% 10px;
    background-position: center center;
    background-repeat: no-repeat;
    transition: opacity 0.2s ease;
    transform: rotate(90deg);
    opacity: 0;
  }

  .outer-circle1 {
    position: absolute; /* Để đảm bảo vòng tròn đồng tâm */
    top: 50%; /* Đẩy lên trên một khoảng bằng với độ dày của viền */
    left: 50%; /* Dịch sang trái một khoảng bằng với độ dày của viền */
    width: 12px; /* Đường kính mới của vòng tròn */
    height: 12px; /* Đường kính mới của vòng tròn */
    border: 2px solid rgba(255, 255, 255, 0.7); /* Viền màu trắng nhạt */
    border-radius: 50%; /* Hình dạng là vòng tròn */
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  .outer-circle2 {
    position: absolute; /* Để đảm bảo vòng tròn đồng tâm */
    top: 50%; /* Đẩy lên trên một khoảng bằng với độ dày của viền */
    left: 50%; /* Dịch sang trái một khoảng bằng với độ dày của viền */
    width: 18px; /* Đường kính mới của vòng tròn */
    height: 18px; /* Đường kính mới của vòng tròn */
    border: 2px solid rgba(255, 255, 255, 0.2); /* Viền màu trắng nhạt */
    border-radius: 50%; /* Hình dạng là vòng tròn */
    transform: translate(-50%, -50%);
    opacity: 0;
  }
`